import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  margin: 20px -10px 0;
`
